import React from 'react';
import type { SupportRequestType } from 'features/my-zone/support-requests/components/support-requests-modals/types';
import {
    RequestPropertyImage,
    RequestTrafficPinImage,
    RequestChainImage,
    RequestMarketImage,
} from 'shared/images/support-requests';

interface CardConfig {
    title: string;
    description: string;
    HeroImage: JSX.Element;
    onClick?: () => void;
    type: SupportRequestType;
    testId: string;
}

export const requestsCardsConfig: CardConfig[] = [
    {
        title: 'Property',
        testId: 'property-request',
        description: 'Specify one or more properties',
        HeroImage: <RequestPropertyImage />,
        type: 'property',
    },
    {
        title: 'Traffic Pin',
        testId: 'traffic-pin-request',
        description: 'Provide coordinates to measure passerby traffic',
        HeroImage: <RequestTrafficPinImage />,
        type: 'trafficPin',
    },
    {
        title: 'Chain',
        testId: 'chain-request',
        description: 'Request chain addition or enacted coverage',
        HeroImage: <RequestChainImage />,
        type: 'chain',
    },
    {
        title: 'Market',
        testId: 'market-request',
        description: 'Request custom polygon',
        HeroImage: <RequestMarketImage />,
        type: 'market',
    },
];
